module.exports = __webpack_public_path__ + "static/img/3.60fe17e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/14/3.png
// module id = EBm+
// module chunks = 2